import React, { useState } from 'react';
import { Input, Tag } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const { CheckableTag } = Tag;

const DisplayTagsPattern = ({ setPattern, pattern, patternOptions }) => {
    const [tagIndexes, setTagIndexes] = useState([]);

    const handleTagClick = tagIndex => {
        if (tagIndexes.includes(tagIndex)) {
            setTagIndexes(tagIndexes.filter(index => index !== tagIndex));
        } else {
            setTagIndexes([...tagIndexes, tagIndex]);
        }
    };

    const handleDeleteTag = tagIndex => {
        const patternParts = pattern.split(/(\${[^}]+})/);
        const newPatternParts = [];
        const newTagIndexes = [];

        patternParts.forEach((part, index) => {
            if (index % 2 === 0 || !tagIndexes.includes((index - 1) / 2)) {
                newPatternParts.push(part);
                if (index % 2 !== 0 && (index - 1) / 2 > tagIndex) {
                    newTagIndexes.push((index - 3) / 2);
                } else {
                    newTagIndexes.push((index - 1) / 2);
                }
            }
        });

        const newPattern = newPatternParts.join('');
        setPattern(newPattern);
        setTagIndexes(newTagIndexes);
    };
    const renderPattern = () => {
        const patternParts = pattern.split(/(\${[^}]+})/);
        return patternParts.map((part, index) => {
            const isTag = index % 2 !== 0;
            const tagIndex = Math.floor(index / 2);

            if (isTag) {
                const tagText = part.slice(2, -1);
                const tagIsChecked = tagIndexes.includes(tagIndex);
                const tagKeyValue = patternOptions?.find(option => `\${${tagText}}` === option.value);
                if (tagKeyValue)
                    return (
                        <CheckableTag
                            style={{ border: '1px solid #1677ff', margin: '5px 2px' }}
                            key={index}
                            checked={tagIsChecked}
                            onChange={() => handleTagClick(tagIndex)}
                            // closable
                            onClose={() => handleDeleteTag(tagIndex)}
                        >
                            {tagKeyValue.key}
                            <CloseOutlined style={{ marginLeft: '0.5rem' }} onClick={() => handleDeleteTag(tagIndex)} />
                        </CheckableTag>
                    );
                return (
                    <CheckableTag
                        style={{ border: '1px solid #a98aff', margin: '5px 2px' }}
                        key={index}
                        checked={tagIsChecked}
                        onChange={() => handleTagClick(tagIndex)}
                        // closable
                        onClose={() => handleDeleteTag(tagIndex)}
                    >
                        {tagText}
                        <CloseOutlined style={{ marginLeft: '0.5rem' }} onClick={() => handleDeleteTag(tagIndex)} />
                    </CheckableTag>
                );
            }

            return <span key={index}>{part}</span>;
        });
    };

    return (
        <div>
            <div
                style={{
                    borderRadius: '3px',
                    // border: '1px dotted #1677ff',
                    padding: '5px',
                    backgroundColor: 'aliceblue',
                }}
            >
                {renderPattern()}
            </div>
        </div>
    );
};

export default DisplayTagsPattern;
